<template>
  <div id="contenedor-registrar-nuevo-programa">
    <v-form v-model="formularioValido" ref="registrarNuevoContratoProgramaObra">
      <v-card flat>
        <v-card-title class="secondary--text">
          Registrar nuevo programa de obra
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mx-2"></v-divider>
        <v-card-text>
          <CustomSelect
            v-show="!esProgramaOrignal"
            v-model="programaDeObra.idConvenio"
            label="Convenio Modificatorio"
            :items="contratoConveniosModificatorios"
            item-value="id"
            item-text="numero"
            clearable>
          </CustomSelect>
          <v-divider v-show="!esProgramaOrignal" class="my-2"></v-divider>
          <v-row no-gutters>
            <v-col cols="12">
              <h4>Datos del contrato</h4>
            </v-col>
            <v-col cols="4">
              Fecha inicio
              <span class="d-block">
                {{ new Date(`${fechaInicio} 00:00:0`).toLocaleDateString() }}
              </span>
            </v-col>
            <v-col cols="4">
              Fecha término
              <span class="d-block">
                {{ new Date(`${fechaTermino} 00:00:0`).toLocaleDateString() }}
              </span>
            </v-col>
            <v-col cols="4">
              Monto Contratado
              <span class="d-block">
                {{ getImporteTotalContratado | currency }}
              </span>
            </v-col>
          </v-row>
          <v-divider class="my-2"></v-divider>
          <agregar-programa
            v-if="!validarMonto"
            v-on:seAgrego="seAgregoPrograma"
            :fecha-inicio="getFechaInicio"
            :fecha-termino="fechaTermino"
            :key="getFechaInicio"
          ></agregar-programa>
          <v-divider class="my-2"></v-divider>
          <v-list>
            <v-list-item-group>
              <template
                v-for="(programa, index) in programaDeObra.programa">
                <template>
                  <v-list-item
                    :key="`programa-${index}`">
                    <v-list-item-action>
                      <v-chip>
                        {{ (index + 1) }}
                      </v-chip>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        <span>
                          {{ new Date(`${programa.fechaInicio} 00:00:0`).toLocaleDateString() }}
                        </span>
                        -
                        <span>
                          {{ new Date(`${programa.fechaTermino} 00:00:0`).toLocaleDateString() }}
                        </span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Plazo {{ programa.plazo }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-row
                        justify="space-between"
                        no-gutters>
                        <v-col
                          class="mr-2">
                          <v-tooltip
                            top>
                            <template
                              v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-if="(index + 1) === programaDeObra.programa.length"
                                @click="remover(index)"
                                icon
                                v-bind="attrs"
                                v-on="on">
                                <v-icon>
                                  mdi-delete
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>Remover registro</span>
                          </v-tooltip>
                        </v-col>
                        <v-col>
                          <v-chip
                            color="#E6E6F9">
                            {{ programa.monto | currency }}
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    :key="`divider-${index}`">
                  </v-divider>
                </template>
              </template>
              <v-list-item>
                <v-list-item-content>
                  <span class="text-right">
                    Restante:
                  </span>
                  <span
                    class="text-right font-weight-bold">
                    {{ (getTotalContratado - sumarMontos) | currency}}
                    </span>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip :color="validarMonto ? 'success' : 'warning'">
                    <v-icon v-if="validarMonto" left>mdi-check</v-icon>
                    {{ sumarMontos | currency }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-divider></v-divider>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarPrograma"
            :disabled="(getTotalContratado - sumarMontos) !== 0"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cerrar">Cancelar</v-btn>
          <v-btn
            color="success"
            @click="mixAgregarPrograma"
            :disabled="(getTotalContratado - sumarMontos) !== 0">
            <v-icon left>mdi-content-save</v-icon>Guardar
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CONTRATO_CONVENIOS_MODIFICATORIOS from '@/graphql/querys/administracion/contratos/contrato/convenios.gql';
import CustomButton from '@/components/buttons/Button.vue';
import CustomSelect from '@/components/inputs/sinColumnas/Select.vue';
import mixProgramaContrato from './mixProgramaContrato';
import AgregarPrograma from './AgregarPrograma.vue';

export default {
  name: 'RegistrarNuevoPrograma',
  mixins: [mixProgramaContrato],
  props: {
    contrato: {
      type: Object,
      required: true,
    },
    esProgramaOrignal: {
      type: Boolean,
      required: false,
      default() {
        return true;
      },
    },
  },
  components: {
    AgregarPrograma,
    CustomButton,
    CustomSelect,
  },
  data() {
    return {
      formularioValido: false,
      enviadoFormulario: false,
      programaDeObra: {
        idContrato: this.contrato.id,
        idConvenio: null,
        programa: [],
      },
    };
  },
  apollo: {
    contratoConveniosModificatorios: {
      query: CONTRATO_CONVENIOS_MODIFICATORIOS,
      variables() {
        return {
          idContrato: this.contrato.id,
        };
      },
    },
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevoContratoProgramaObra.reset();
      this.programaDeObra.programa = [];
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    getImporteTotalContratado() {
      return (this.contrato.importe + this.contrato.modificado.importe);
    },
  },
};
</script>

<style lang="scss">
</style>
